// extracted by mini-css-extract-plugin
export default {"this":"Copy-module--this--jMpIj"};